<div class="inicio">
  <p class="titulo"> EXPEDIENTE DE SOLICITUDES DE COLABORADOR
    <mat-icon color="primary" matTooltip="Click para más información" (click)="botonInformacion()">info</mat-icon>
  </p>
  <!--TABLA CON LOS DATOS -->
  <div class="div">

    <!--Nombre del colaborador-->
    <div class="grid-container">
      <mat-label class="label">Nombre del colaborador </mat-label>
      <mat-progress-bar *ngIf="cargando" mode="indeterminate"></mat-progress-bar>
      <mat-form-field appearance="outline">
        <mat-select placeholder="Escribe el nombre del colaborador" [formControl]="colaboradorFiltrar" #singleSelect1
          (selectionChange)="llenarTablaExpSolicitudes()" (selectionChange)="cargarDatosColaborador($event)">
          <mat-option>
            <ngx-mat-select-search [formControl]="inputColaboradorF"
              oninput="this.value ? this.value = this.value.toUpperCase() : null">
              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
              <span ngxMatSelectNoEntriesFound>
                No se encontraron opciones
              </span>
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let option of listaFiltradaEmp | async" [value]="option">
            {{option.nomb_compl}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!--Tabla-->
    <table mat-table [dataSource]="dataSourceSolicitud" class="mat-elevation-z8">
      <ng-container matColumnDef="visualizarSoli">
        <th mat-header-cell *matHeaderCellDef> VISUALIZAR </th>
        <td mat-cell *matCellDef="let element">
          <button mat-mini-fab matTooltip="Detalle de la solicitud" style="background-color: #00bd39c2;"
            (click)="visualizarSolicitud(element.id_solicitud)"> <mat-icon>visibility</mat-icon> </button>
          <p></p>
        </td>
      </ng-container>
      <ng-container matColumnDef="id_solicitud">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> N° SOLICITUD </th>
        <td mat-cell *matCellDef="let element"> {{element.id_solicitud}} </td>
      </ng-container>
      <ng-container matColumnDef="name_tipo_solicitud">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TIPO </th>
        <td mat-cell *matCellDef="let element"> {{element.tipoSolicitud}} </td>
      </ng-container>
      <ng-container matColumnDef="status_solicitud">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS </th>
        <td mat-cell *matCellDef="let element"> {{element.status_solicitud}} </td>
      </ng-container>
      <ng-container matColumnDef="nomColaborador">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> COLABORADOR </th>
        <td mat-cell *matCellDef="let element"> {{element.colaborador}} </td>
      </ng-container>
      <ng-container matColumnDef="nomPuesto">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> CARGO DEL COLABORADOR </th>
        <td mat-cell *matCellDef="let element"> {{element.puesto}} </td>
      </ng-container>
      <ng-container matColumnDef="name_sucursalCol">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL DEL COLABORADOR </th>
        <td mat-cell *matCellDef="let element"> {{element.sucursal}} </td>
      </ng-container>
      <ng-container matColumnDef="fechaSolicitud">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> FECHA DE SOLICITUD </th>
        <td mat-cell *matCellDef="let element"> {{element.fecha_solicitud?.substring(0,10)}} </td>
      </ng-container>
      <ng-container matColumnDef="fechaModificacion">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ÚLTIMA MODIFICACIÓN</th>
        <td mat-cell *matCellDef="let element"> {{element.fecha_modificacion?.substring(0,10)}} </td>
      </ng-container>

      <ng-container matColumnDef="responsiva">
        <th mat-header-cell *matHeaderCellDef> RESPONSIVA </th>
        <td mat-cell *matCellDef="let element">
          <button mat-mini-fab matTooltip="Descargar responsiva" style="background-color: #0804e9;"
            (click)="descargarResponsiva(element)" [disabled]="cargando"> <mat-icon>file_download</mat-icon>
          </button>
          <button mat-mini-fab matTooltip="Visualizar responsiva" style="background-color: #ff3bde;"
            (click)="mostrarResponsiva(element)" [disabled]="cargando"> <mat-icon>visibility</mat-icon> </button>
          <button mat-mini-fab matTooltip="Reemplazar responsiva" style="background-color: #1d9be4;"
            [disabled]="cargando" (click)="subirResponsiva(element)">
            <mat-icon>autorenew</mat-icon> </button>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
      <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No se han encontrado resultados</td>
      </tr>
    </table>
    <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]"
      showFirstLastButtons></mat-paginator>
  </div>
</div>